import { render, staticRenderFns } from "./Comp54t3.vue?vue&type=template&id=831512ae&scoped=true&"
import script from "./Comp54t3.vue?vue&type=script&lang=js&"
export * from "./Comp54t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp54t3.vue?vue&type=style&index=0&id=831512ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831512ae",
  null
  
)

export default component.exports